/* asvendo elektro — cinematic entrance (scroll-triggered) + parallax.
   CSS transitions drive the reveal; JS just toggles .asv-shown with stagger.
   Bulletproof: failsafe shows everything; reduced-motion respected. */
(function () {
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function show(el) { el.classList.add("asv-shown"); }
  function showAll() { document.querySelectorAll(".asv-anim:not(.asv-shown)").forEach(show); }

  function init() {
    var els = [].slice.call(document.querySelectorAll(".asv-anim"));
    if (!els.length) { /* still wire parallax below */ }

    // stagger delay = index among .asv-anim siblings in same parent
    els.forEach(function (el) {
      var sibs = [].slice.call(el.parentNode.children).filter(function (c) { return c.classList && c.classList.contains("asv-anim"); });
      var i = sibs.indexOf(el);
      el.style.transitionDelay = (Math.max(0, i) * 0.08) + "s";
    });

    if (reduce || !("IntersectionObserver" in window)) {
      showAll();
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } });
      }, { rootMargin: "0px 0px -8% 0px", threshold: 0.05 });
      els.forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 0.92) show(el); // above fold: instant
        else io.observe(el);
      });
    }

    // FAILSAFES
    setTimeout(showAll, 1800);
    window.addEventListener("load", function () { setTimeout(showAll, 500); });

    // Parallax glows
    var glows = [].slice.call(document.querySelectorAll("[data-asv-parallax]"));
    if (glows.length && !reduce) {
      var tick = false;
      window.addEventListener("scroll", function () {
        if (tick) return; tick = true;
        requestAnimationFrame(function () {
          var y = window.scrollY;
          glows.forEach(function (el) {
            var f = parseFloat(el.getAttribute("data-asv-parallax")) || 0.1;
            el.style.transform = "translate3d(0," + (y * f) + "px,0)";
          });
          tick = false;
        });
      }, { passive: true });
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);
})();
